/** Convert ISO / Date → value for `<input type="datetime-local">` (local wall clock). */
export function toDatetimeLocalValue(value: string | Date | null | undefined): string {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Local datetime-local string → ISO UTC for GraphQL DateTime. */
export function fromDatetimeLocalValue(value: string | null | undefined): string | null {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function splitDatetimeLocal(value: string | null | undefined): { date: string; time: string } {
  if (!value) return { date: "", time: "" };
  const [date = "", timePart = ""] = value.split("T");
  return { date, time: timePart.slice(0, 5) };
}

/** Join date (`YYYY-MM-DD`) + time (`HH:mm`) into a datetime-local string. */
export function joinDatetimeLocal(date: string, time: string, allDay = false): string {
  if (!date) return "";
  if (allDay) return `${date}T00:00`;
  return `${date}T${time || "09:00"}`;
}

/** Add minutes to a datetime-local string; returns "" if invalid. */
export function addMinutesToDatetimeLocal(value: string, minutes: number): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  d.setMinutes(d.getMinutes() + minutes);
  return toDatetimeLocalValue(d);
}

/** @deprecated Prefer `graphqlEnumOptions` from `$lib/enums` — uses GraphQL names as Select values. */
export function enumOptions(values: readonly string[]): { value: string; label: string }[] {
  return values.map((value) => ({
    value,
    label: value
      .split("_")
      .map((p) => p.charAt(0) + p.slice(1).toLowerCase())
      .join(" "),
  }));
}
